export default "__VITE_ASSET__D5to8zzP__"